import {inlineError} from '@s-ui/decorators/lib'
import {Service} from '@s-ui/domain'

/**
 * @implements Service
 */
export class ValidatePhoneVerificationCodeUserService extends Service {
  /**
   * @constructor
   * @param {Object} deps
   * @param {RequestFactory} deps.updateCurrentUserRequestFactory
   * @param {Service} deps.updateCurrentUserService
   * @param {ErrorFactory} deps.userNotLoggedInUserErrorFactory
   * @param {Repository} deps.userRepository
   */
  constructor({
    updateCurrentUserRequestFactory,
    updateCurrentUserService,
    userNotLoggedInUserErrorFactory,
    userRepository
  }) {
    super()

    this._updateCurrentUserRequestFactory = updateCurrentUserRequestFactory
    this._updateCurrentUserService = updateCurrentUserService
    this._userNotLoggedInUserErrorFactory = userNotLoggedInUserErrorFactory
    this._userRepository = userRepository
  }

  @inlineError
  async execute({userEntity, validatePhoneVerificationCodeUserRequest}) {
    if (!userEntity)
      return Promise.reject(
        this._userNotLoggedInUserErrorFactory({
          message: 'To validate phone verification code the user must be logged in'
        }).toJSON()
      )

    const [error] = await this._userRepository.validatePhoneVerificationCode({
      userEntity,
      validatePhoneVerificationCodeUserRequest
    })

    if (error) return Promise.reject(JSON.parse(error.message))

    const {phone} = validatePhoneVerificationCodeUserRequest.toJSON()

    const updateCurrentUserRequest = this._updateCurrentUserRequestFactory({
      phone
    })

    return this._updateCurrentUserService
      .execute({
        updateCurrentUserRequest
      })
      .then(userEntity => (userEntity ? userEntity.toJSON() : null))
  }
}
